import classNames from 'classnames';
import React, { cloneElement, forwardRef } from 'react';
import styles from "./DropdownContent.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const DropdownContent = /*#__PURE__*/forwardRef(({
  useChildAsButton,
  onKeyDown,
  onBlur,
  getReferenceProps,
  props,
  className,
  child
}, ref) => {
  if (useChildAsButton) {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      throw new Error('Invalid Dropdown childs');
    }
    return /*#__PURE__*/cloneElement(child, {
      ...getReferenceProps({
        ...props,
        className: classNames(styles.menuButton, child.props?.className, className),
        tabIndex: 0,
        onKeyDown,
        onBlur
      })
    });
  }
  return /*#__PURE__*/_jsx("button", {
    ...getReferenceProps({
      ...props,
      ref,
      className: classNames(styles.menuButton, className),
      tabIndex: 0,
      onKeyDown,
      onBlur
    }),
    type: "button",
    children: child
  });
});